import { ReactComponent as InfoIcon } from '@assets/images/infoIcon.svg';
import './style.scss';

export type InfoNotificationData = {
  title: string;
  content: string[];
  testId?: string;
};

export const InfoNotification = ({
  title,
  content,
  testId,
}: InfoNotificationData) => {
  return (
    <div className="info-notification" data-testid={testId}>
      <InfoIcon />
      <div className="info-notification__content">
        <h3>{title}</h3>
        {content.length > 0 && (
          <ul>
            {content.map((item) => (
              <li key={item}>
                {/* eslint-disable-next-line react/no-danger */}
                <div dangerouslySetInnerHTML={{ __html: item }} />
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
